import {useRuntimeConfig} from '#app';

export default function useModuleConfig() {
    return useRuntimeConfig().public['@malt/nuxt-marketing-module'];
}
